export default __webpack_public_path__ + "09ab6bcbf70f5373837890b41fd33dff.jpg";